/**
 * I giochi, in un elenco solo.
 *
 * Stavano scritti dentro Header.js, e la barra in basso li avrebbe riscritti
 * uguali: due elenchi della stessa cosa, che il giorno in cui se ne aggiunge
 * uno si scordano. Da qui li legge sia la riga in alto sia il foglio che si
 * apre dalla barra in basso.
 *
 * Le sezioni vengono dal CATALOGO DEI MODULI (moduli/catalogo.json), lo
 * stesso che legge il backoffice: la chiave dell'interruttore (sport,
 * liveSport, ...) e' quella che il backoffice scrive in skin.sections. Una
 * sezione spenta sulla skin sparisce dalla riga, dal foglio e dalla barra.
 */
import {CATALOGO, sezioniAccese} from '../moduli/leggi';

const HOME = {name: 'home', img: 'home', path: '/', chiave: 'home'};

const voce = (s) => ({name: s.voce, img: s.icona, path: s.percorso, chiave: s.chiave});

/** Tutte le voci, accese o no: serve a chi deve riconoscere un indirizzo. */
export const GIOCHI = [HOME].concat(CATALOGO.sezioni.map(voce));

/** Le voci da mostrare: la Home e le sezioni accese sulla skin. */
export function giochiAccesi() {
  return [HOME].concat(sezioniAccese().map(voce));
}

/**
 * Il percorso di una voce: quello scritto, oppure il nome fatto indirizzo
 * ("live sport" -> "/live-sport").
 *
 * Anche questa regola stava in un posto solo (MenuItem) e serviva in due:
 * riscriverla accanto avrebbe voluto dire due modi di ricavare lo stesso
 * indirizzo, cioe' due modi di sbagliarlo.
 */
export function percorsoDiVoce(voce) {
  return (voce && voce.path) ||
    '/' + String((voce && voce.name) || '').trim().replace(/\s+/g, '-').toLowerCase();
}
